import React from 'react';

import { Dialog } from '@mui/material';

import Button from '../common/Button';

type SimpleConfirmDeleteDialogProps = {
  title?: string;
  open: boolean;
  isLoading: boolean;
  content?: React.ReactNode;
  handleOnClose: () => void;
  handleOnSubmit: () => void;
};

const SimpleConfirmDeleteDialog = ({
  title,
  open,
  handleOnClose,
  handleOnSubmit,
  isLoading,
  content,
}: SimpleConfirmDeleteDialogProps) => (
  <Dialog
    open={open}
    aria-labelledby="alertTitle"
    aria-describedby="alertContent"
  >
    <div className="flex flex-col gap-6 p-6">
      <h2 className="text-xl font-bold">
        {title ?? 'Are you sure you want to delete?'}{' '}
      </h2>
      {content && <div className="text-base text-[#666]">{content}</div>}
      <div className="flex justify-end gap-3">
        <Button
          onClick={handleOnClose}
          variant="outlined"
          tabIndex={3}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          onClick={handleOnSubmit}
          tabIndex={2}
          disabled={isLoading}
          loading={isLoading}
          variant="contained_red"
        >
          Yes, delete it
        </Button>
      </div>
    </div>
  </Dialog>
);

export default SimpleConfirmDeleteDialog;
